import React, { useState } from 'react';
import CarFeaturesForm      from '../CarFeaturesForm';
import CarBenefitsForm      from '../CarBenefitsForm';
import CarSpecificationsForm from '../CarSpecificationsForm';
import { adminCarContentService } from '../../../services/adminService';

const CarContentModal = ({ inspection, onClose, onSuccess }) => {
  const [activeTab,   setActiveTab]   = useState('features');
  const [processing,  setProcessing]  = useState(false);

  const tabs = [
    { id: 'features',       label: 'Features',       icon: '🚗' },
    { id: 'benefits',       label: 'Benefits',       icon: '💎' },
    { id: 'specifications', label: 'Specifications', icon: '⚙️' }
  ];

  // Calls PUT /api/v1/admin/cars/:car_id/content/verify
  // Backend checks: inspection_status == "approved" (set when car was created)
  // Sets: content_verified = true
  // After this: car moves to Stage 4 (ready to publish)
  const handleVerifyContent = async () => {
    if (!window.confirm("Verify this car's content? This will mark it as ready for publishing.")) return;
    try {
      setProcessing(true);
      await adminCarContentService.verifyContent(inspection.car_id);
      alert('✅ Car content verified! Car is now ready to publish.');
      onSuccess();
    } catch (err) {
      console.error('Content verification error:', err);
      alert('Failed: ' + (err.response?.data?.message || err.message));
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-large car-content-modal" onClick={e => e.stopPropagation()}>

        <div className="modal-header">
          <div>
            <h2>📝 Car Content Management</h2>
            <p>Car ID: #{inspection.car_id} | {inspection.sell_request?.brand} {inspection.sell_request?.model} {inspection.sell_request?.year}</p>
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {/* Tabs */}
        <div className="modal-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="modal-body">
          {activeTab === 'features'       && <CarFeaturesForm       carId={inspection.car_id} />}
          {activeTab === 'benefits'       && <CarBenefitsForm       carId={inspection.car_id} />}
          {activeTab === 'specifications' && <CarSpecificationsForm carId={inspection.car_id} />}
        </div>

        <div className="modal-footer">
          <button className="btn-modal-cancel" onClick={onClose} disabled={processing}>
            Close
          </button>
          <button
            className="btn-modal-submit btn-verify"
            onClick={handleVerifyContent}
            disabled={processing}
          >
            {processing ? '⏳ Processing…' : '✅ Verify & Complete Content'}
          </button>
        </div>

      </div>
    </div>
  );
};

export default CarContentModal;